import { PaziaHeader } from "components/atoms/PaziaHeader/PaziaHeader";
import React from "react";

interface PageRichHeaderProps {
  children: React.ReactNode;
  header: string;
}
export const PageRichHeader = ({ children, header }: PageRichHeaderProps): JSX.Element | null => {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 pb-4">
      {/* PaziaHeader is nowrap; on a phone a long title wraps instead of running off-screen */}
      <div className="min-w-0 max-w-full [&>span]:whitespace-normal">
        <PaziaHeader>{header}</PaziaHeader>
      </div>
      {children}
    </div>
  );
};
